import sideMenu from './sidenav.menu';

class SidenavController {
  constructor($rootScope, $state, $timeout, Auth) {
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$timeout = $timeout;
    this.Auth = Auth;
    this.name = 'sidenav';
    this.setup();
  }

  isAuthorized(menuItem) {
    if (this.$rootScope.user.access_group.is_super) {
      return true;
    }
    
    let authorizedModules = this.Auth.getAuthorizedModules(this.$rootScope.user.access_group);
    return authorizedModules.indexOf(menuItem.title) > -1;
  }

  // Local functions

  setup() {
    this.setupSideNav();
  }

  setupSideNav() {
    this.sideMenu = sideMenu;
    this.openActiveMenu();
  }

  openActiveMenu() {
    this.$timeout(() => {
      let activeMenuItem = _.find(this.sideMenu,  menuItem => {
        return menuItem.subMenu && _.find(menuItem.subMenu, subMenuItem => {
          if (subMenuItem.children) {
            return subMenuItem.children.indexOf(this.$state.current.name) > -1;
          }
        });
      });

      if (activeMenuItem) {activeMenuItem.isOpen = true;}

    }, 100);
  }
}

SidenavController.$inject = ['$rootScope', '$state', '$timeout', 'Auth'];

export default SidenavController;



// WEBPACK FOOTER //
// ./client/app/common/layout/sidenav/sidenav.controller.js